import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';

export const searchReactFr = createTranslationMessages({
  ref: searchReactTranslationRef,
  full: true,
  messages: {
    'searchBar.title': 'Rechercher',
    'searchBar.placeholder': 'Rechercher dans {{org}}',
    'searchBar.clearButtonTitle': 'Effacer',
    'searchFilter.allOptionTitle': 'Tout',
    'searchPagination.limitLabel': 'Résultats par page :',
    'searchPagination.limitText': 'sur {{num}}',
    noResultsDescription: 'Désolé, aucun résultat n’a été trouvé',
    'searchResultGroup.linkTitle': 'Tout voir',
    'searchResultGroup.addFilterButtonTitle': 'Ajouter un filtre',
    'searchResultPager.next': 'Suivant',
    'searchResultPager.previous': 'Précédent',
  },
});
